// extracted by mini-css-extract-plugin
export default {"label":"Jc5fvK","inputGroup":"NXasVK","spinnerArrows":"CupGjl","upArrow":"bzZYud","downArrow":"JQzGBd","disabled":"OBkWx9"};